import { RootState } from "../../store/root-reducer";
import { connect } from "react-redux";
import { MiniPlanCard } from "../../components/PlanCard";
import ClaimItemBox from "../../components/CreateAce2Claim/ReportDamage/ClaimItemBox";

function ReportDamage({ claim_items, plan }) {
  return (
    <div className="flex gap-4 flex-col">
      <MiniPlanCard plan={plan} />
      {claim_items.map((item, idx) => (
        <ClaimItemBox key={item.id} item={item} idx={idx} />
      ))}
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  claim_items: state?.ace2Claim?.claim_items || [],
  plan: state?.ace2Claim?.plan || {},
});

export default connect(mapStateToProps)(ReportDamage);
